module.exports = __webpack_public_path__ + "media/images/icon/icon_girls-509cec3f03bba93f72582955f268fe39.png";